module.exports = __webpack_public_path__ + "img/icon2.50caf58e.png";